import EmberRouter from '@embroider/router';
import config from 'invite-sign/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('invite', { path: '/invite/:id' }, function () {
    this.route('show', { path: '' }, function () {
      this.route('agreement', { path: 'agreement/:agreement_id' });
      this.route('document', { path: 'document/:document_id' });
      this.route('prereg-document', { path: 'prereg-document/:requirement_id' });
      // eslint-disable-next-line ember/no-shadow-route-definition
      this.route('fill', { path: '' });
      this.route('group-landing');
      this.route('id-scan');
      this.route('picture');
      this.route('questionnaires', function () {
        this.route('take', { path: '/:questionnaire_id' });
      });
      this.route('submitted');
    });
    this.route('already-submitted');
    this.route('status');
  });

  this.route('protect', { path: '/protect/:protect_access_code_id' }, function () {
    this.route('show', { path: '' });
    this.route('callback');
    this.route('register');
    this.route('sign-in');
    this.route('sign-out');
    this.route('skip-employee-screening');
    this.route('submitted');
  });

  this.route('visitor', { path: '/' }, function () {
    this.route('add-photo');
    this.route('data-opt-out');
    this.route('data-policy');
    this.route('employee-registration');
    this.route('id-scan');
    this.route('name');
    this.route('personal-details');
    this.route('questionnaires');
    this.route('sign-documents');
    this.route('sign-out');
    this.route('sign-out-complete');
    this.route('submitted');
    this.route('upload-documents', { path: 'upload-documents/:document_id' });
    this.route('verify-match');
    this.route('visitor-type');
    this.route('welcome');
  });

  this.route('in', function () {
    this.route('error');
    this.route('authenticate', { path: '/:public_token' });
    this.route('shared', { path: '/:public_token/shared' });
    this.route('disconnect-shared', { path: '/:public_token/disconnect-shared' });
  });

  this.route('group-invite', { path: '/group-invite/:public_token' }, function () {
    this.route('show', { path: '' }, function () {
      // eslint-disable-next-line ember/no-shadow-route-definition
      this.route('fill', { path: '' });
      this.route('exceeded');
      this.route('expired');
    });
  });

  this.route('signed-out');
  this.route('try-again');
  this.route('unauthorized');
  this.route('expired');
  this.route('exceeded');
});
